module.exports = __webpack_public_path__ + "img/celery.92bfb28c.svg";